import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.to(".scroll-down", {
    scrollTrigger: {
        trigger: "#top",
        start: "60px top",
        //markers: true
    },
    opacity: 0
});

import EmblaCarousel from 'embla-carousel';
import { addDotBtnsAndClickHandlers } from './EmblaCarouselDotButton'

const emblaNode = document.querySelector('.embla');
if (emblaNode) {
    const embla = EmblaCarousel(emblaNode, {
        active: true,
        loop: false,
        align: 'start',
        dragFree: false,
        containScroll: 'trimSnaps', // Hindrer at man drar inn tomrom på slutten
        slides: 'li.embla__card',
    });

    // Grab button nodes
    const prevButtonNode = emblaNode.querySelector('.embla__prev')
    const nextButtonNode = emblaNode.querySelector('.embla__next')

    // Add click listeners
    prevButtonNode.addEventListener('click', embla.scrollPrev, false)
    nextButtonNode.addEventListener('click', embla.scrollNext, true)

    console.log('✅ Embla Carousel is initialized:', embla);
    console.log('Slides:', embla.slideNodes().length); // Skal være > 1
    console.log('Snap points:', embla.scrollSnapList()); // Skal være > 1 verdi
}

const minaSlides = document.querySelector('.mina');
if (minaSlides) {
    const mina = EmblaCarousel(minaSlides, {
        active: true,
        loop: false,
        align: 'start',
        dragFree: false,
        containScroll: 'trimSnaps', // Hindrer at man drar inn tomrom på slutten
        slides: 'li.mina__slide',
    });

    // Grab button nodes
    const prevButtonNode = minaSlides.querySelector('.mina__prev')
    const nextButtonNode = minaSlides.querySelector('.mina__next')

    // Add click listeners
    prevButtonNode.addEventListener('click', mina.scrollPrev, false)
    nextButtonNode.addEventListener('click', mina.scrollNext, true)

    const dotsNode = minaSlides.querySelector('.mina__dots')
    addDotBtnsAndClickHandlers(mina, dotsNode)

}
